<template>
  <service-view
    :pictures="pictures"
    :serviceTitle="serviceTitle"
    :stoneCladdingActive="'active'"
    :serviceDescription="serviceDescription"
  />
</template>
<script>
import ServiceView from "./ServiceView";
export default {
  name: "Carpentrey",
  components: {
    ServiceView
  },
  data: () => ({
    pictures: [
      {
        name: "stone_cladding/IMG-20170823-WA0027.jpg",
        title: "Constructing a factory",
        location: "Zambia"
      },
      {
        name: "stone_cladding/IMG-20171007-WA0094.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "stone_cladding/IMG-20180125-WA0001.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "stone_cladding/IMG-20180125-WA0004.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      },
      {
        name: "stone_cladding/IMG-20180125-WA0010.jpg",
        title: "Swimming pool construction",
        location: "Zambia"
      }
    ],
    serviceTitle: "Stone cladding",
    serviceDescription:
      "We offer stone cladding  that can be used to transform any wall from being uninspiring and plain into a Wall of natural  beauty"
  })
};
</script>
